export default __webpack_public_path__ + "static/media/WEBB_TOT2021.1dce9366.png";